import React, { useEffect } from 'react';
import Footer from '../Footer/Footer';
import './legal.css';

const LegalLayout = ({ title, updated, children }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="legal-page">
      <header className="legal-hero">
        <h1>{title}</h1>
        <p className="legal-updated">Last updated: {updated}</p>
      </header>
      <main className="legal-content">{children}</main>
      <Footer />
    </div>
  );
};

export default LegalLayout;
